import { OpaqueToken, Provider } from '@angular/core';

export const /** @type {?} */ GoldenLayoutStateStore = new OpaqueToken('GoldenLayoutStateStore');

export interface StateStore {
  writeState(state:any): void;

  loadState(): Promise<any>
}

export const /** @type {?} */ DEFAULT_LOCAL_STORAGE_STATE_STORE_KEY = '$ng-golden-layout-state';
export class LocalStorageStateStore implements StateStore {
/**
 * @param {?} key
 */
constructor(private readonly key: string) {}
/**
 * @param {?} state
 * @return {?}
 */
public writeState(state: any): void { 
    localStorage.setItem(this.key, JSON.stringify(state));
  }
/**
 * @return {?}
 */
public loadState(): Promise<any> {
    const /** @type {?} */ state = localStorage.getItem( this.key );
    return state 
      ? Promise.resolve(JSON.parse(state)) 
      : Promise.reject(`No state found using key: ${this.key}`);
  }
}

function LocalStorageStateStore_tsickle_Closure_declarations() {
/** @type {?} */
LocalStorageStateStore.prototype.key;
}

/**
 * @return {?}
 */
export function DEFAULT_LOCAL_STORAGE_STATE_STORE_FACTORY() {
  return new LocalStorageStateStore(DEFAULT_LOCAL_STORAGE_STATE_STORE_KEY);
}

export const /** @type {?} */ DEFAULT_LOCAL_STORAGE_STATE_STORE = new LocalStorageStateStore(DEFAULT_LOCAL_STORAGE_STATE_STORE_KEY);

export const /** @type {?} */ DEFAULT_LOCAL_STORAGE_STATE_STORE_PROVIDER: Provider = {
  provide: GoldenLayoutStateStore,
  useFactory: DEFAULT_LOCAL_STORAGE_STATE_STORE_FACTORY
};
